'use client';

import { useToast } from '@common/hooks';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

import LoadingPageTemplate from '../loading';

export const GlobalLoadingPageTemplate = () => {
  const isLogin = useAuthStore((state) => state.isLogin);

  const searchParams = useSearchParams();

  const router = useCustomRouter();

  const { toast } = useToast();

  const toastSearchParams = searchParams?.get('toast');

  const isLoading = isLogin === undefined;

  useEffect(() => {
    if (!toastSearchParams || isLoading) return;

    toast({
      message: toastSearchParams,
    });

    const url = new URL(window.location.href);

    url.searchParams.delete('toast');

    router.replace(url.toString());
  }, [toastSearchParams, toast, router, isLoading]);

  return isLoading ? <LoadingPageTemplate unmountedPlaceholder /> : null;
};
